<script>
import Layout from '@layouts/main'

export default {
  page: {
    title: 'Cargando...',
    meta: [{ name: 'description', content: 'Cargando...' }],
  },
  components: { Layout },
}
</script>

<template>
  <Layout>
    <Transition appear>
      <b-spinner :class="$style.loadingIcon" variant="primary" label="Spinning"></b-spinner>
    </Transition>
  </Layout>
</template>

<style lang="scss" module>
.loadingIcon {
  display: block;
  margin: 0 auto;

  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter-active) {
    transition: opacity 1s;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter) {
    opacity: 0;
  }
}
</style>
